import { ToastProvider } from './contexts/ToastContext'
import { ConnectionProvider, useConnection } from './features/connection/ConnectionContext'
import { UploadProvider } from './features/upload/UploadContext'
import { PhotoIndexProvider, usePhotoIndexContext } from './features/calendar/PhotoIndexContext'
import { GoogleAuthProvider } from './features/google-photos/GoogleAuthContext'
import { SplashScreen } from './components/layout/SplashScreen'
import { MainLayout } from './components/layout/MainLayout'

function AppContent() {
  const { isConnected } = useConnection()

  if (!isConnected) {
    return <SplashScreen />
  }

  return <MainLayout />
}

function AppWithUpload() {
  const { fetchIndex } = usePhotoIndexContext()

  return (
    <UploadProvider onUploadComplete={fetchIndex}>
      <AppContent />
    </UploadProvider>
  )
}

function App() {
  return (
    <ToastProvider>
      <GoogleAuthProvider>
        <ConnectionProvider>
          <PhotoIndexProvider>
            <AppWithUpload />
          </PhotoIndexProvider>
        </ConnectionProvider>
      </GoogleAuthProvider>
    </ToastProvider>
  )
}

export default App
